import React from 'react';

import { TabsPage } from '../Tabs';
import { handleSubmit } from '../../utils/auth';

const MainPage = () => {
    return (
        <div className="container">
            <TabsPage handleCheck={handleSubmit} />
        </div>
    );
};

export default MainPage;
